import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// vo 객체 활용
const initialState: any = {
  imgSaveFiles: [],
  imgUrlFiles: [],
  apiData: []
};

// 2. slice 생성 : createSlice
const fileSlice = createSlice({
  name: "banner",
  initialState,
  reducers: {
    setSaveImg: (state, action: PayloadAction<any>) => {
      state.imgSaveFiles.push(action.payload);
    },
    setUrlImg: (state, action: PayloadAction<any>) => {
      state.imgUrlFiles.push(action.payload);
    },
    setDeleteImg: (state, action: PayloadAction<number>) => {
      const tempSaveArray = state.imgSaveFiles.filter((_el: any, idx: number) => idx !== Number(action.payload));
      // state.imgSaveFiles = action.payload;
      state.imgSaveFiles = tempSaveArray;

      const tempUrlArray = state.imgUrlFiles.filter((_el: any, idx: number) => idx !== Number(action.payload));
      // state.imgSaveFiles = action.payload;
      state.imgUrlFiles = tempUrlArray;
    },
    setApiData: (state, action: PayloadAction<any>) => {
      state.apiData = action.payload;
    },
    resetRecudeData: (state, action: PayloadAction<string>) => {
      if (action.payload === "reset") {
        state.imgSaveFiles = []
        state.imgUrlFiles = []
        state.apiData = []
      }
    },
  },
});

export const { setSaveImg, setUrlImg, setDeleteImg, setApiData, resetRecudeData } = fileSlice.actions;
export default fileSlice.reducer;